import { h, createApp } from "vue";
import singleSpaVue from "single-spa-vue";
import Notifications from "@kyvg/vue3-notification";
import singleSpaCss from "single-spa-css";

import "@/assets/scss/main.scss";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";

import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import Gleap from "gleap";
import bootstrapVue from "bootstrap-vue-next";

const cssConfig = {
  webpackExtractedCss: false,
  shouldUnmount: true,
  timeout: 15000,
  createLink(url) {
    const linkEl = document.createElement("link");
    linkEl.rel = "stylesheet";
    linkEl.href = url;
    return linkEl;
  },
};
if (process.env.NODE_ENV === "production") {
  cssConfig.cssUrls = [
    process.env.VUE_APP_VUE3_APP_URL +
      "/css/app.css?v=" +
      process.env.VUE_APP_CSS_VERSION,
  ];
}
const cssLifecycles = singleSpaCss(cssConfig);

const vueLifecycles = singleSpaVue({
  createApp,
  appOptions: {
    render() {
      return h(App, {
        // single-spa props are available on the "this" object. Forward them to your component as needed.
        // https://single-spa.js.org/docs/building-applications#lifecycle-props
        // if you uncomment these, remember to add matching prop definitions for them in your App.vue file.
        /*
        name: this.name,
        mountParcel: this.mountParcel,
        singleSpa: this.singleSpa,
        */
      });
    },
    mounted() {
      Gleap.initialize(process.env.VUE_APP_GLEAP_KEY);

      // Access GTM if it exists
      if (window.dataLayer) {
        // You can push events to GTM here if needed
        window.dataLayer.push({
          event: "vue3-app-mounted",
          appName: "vue3-app",
        });
      }
    },
  },
  handleInstance(app) {
    // app.use(mailerCloud);
    // app.use(BootstrapVue3);
    app.use(bootstrapVue({ plugins: { modalController: true } }));
    app.use(Notifications);
    app.use(router);
    app.use(createPinia());
    // app.directive("b-tooltip", vBTooltip);
    // Sentry.init({
    //   app,
    //   dsn: process.env.VUE_APP_SENTRY_DSN,
    //   integrations: [
    //     Sentry.browserTracingIntegration({
    //       enableInp: true,
    //     }),
    //     Sentry.replayIntegration({
    //       maskAllText: false,
    //       blockAllMedia: false,
    //     }),
    //   ],
    //   // Performance Monitoring
    //   tracesSampleRate: 1.0, //  Capture 100% of the transactions
    //   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    //   tracePropagationTargets: [
    //     process.env.TRACE_PROPAGATION_TARGET_1,
    //     // new RegExp(process.env.TRACE_PROPAGATION_TARGET_2),
    //     // new RegExp(process.env.TRACE_PROPAGATION_TARGET_3),
    //     // new RegExp(process.env.TRACE_PROPAGATION_TARGET_4),
    //   ],
    //   // Session Replay
    //   replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    //   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    // });
    // Sentry.setUser({
    //   id: userLoginData?.cid,
    // });
    // Sentry.setTag("plan_type", userLoginData?.plan);

    // Add a global property to access GTM throughout the app
    app.config.globalProperties.$gtag = function () {
      if (window.gtag) {
        window.gtag.apply(null, arguments);
      }
    };
  },
});

// Export an array of lifecycles to integrate with a framework's
// single-spa lifecycles. The order matters.
export const bootstrap = [cssLifecycles.bootstrap, vueLifecycles.bootstrap];

export const mount = [
  // The CSS lifecycles should be before your framework's mount lifecycle,
  // to avoid a Flash of Unstyled Content (FOUC)
  cssLifecycles.mount,
  vueLifecycles.mount,
];

export const unmount = [
  // The CSS lifecycles should be after your framework's unmount lifecycle,
  // to avoid a Flash of Unstyled Content (FOUC)
  vueLifecycles.unmount,
  cssLifecycles.unmount,
];
